module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.cupomDetalhesModal),
      callback: function($$v) {
        _vm.cupomDetalhesModal = $$v
      },
      expression: "cupomDetalhesModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v(_vm._s(_vm.cupom.id === 0 ? 'Novo cupom de desconto' : _vm.cupom.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-form', {
    ref: "itemForm",
    attrs: {
      "name": "form-cadastro"
    }
  }, [_c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "label": "Nome",
      "rules": _vm.rules.name,
      "value": typeof _vm.cupom.name !== 'undefined' ? _vm.cupom.name : '',
      "required": ""
    },
    on: {
      "input": _vm.updateName
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": "",
      "md3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "rules": _vm.rules.type,
      "value": _vm.cupom.type,
      "items": _vm.listTypes,
      "label": "Tipo",
      "single-line": "",
      "item-text": "label",
      "item-value": "value",
      "required": ""
    },
    on: {
      "input": _vm.updateType
    },
    model: {
      value: (_vm.cupom.type),
      callback: function($$v) {
        _vm.$set(_vm.cupom, "type", $$v)
      },
      expression: "cupom.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Se o desconto em é em porcentagem ou valor fixo.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('span', {
    staticClass: "label-amount"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('the-mask', {
    staticClass: "the-mask-money",
    attrs: {
      "rules": _vm.rules.amount,
      "value": _vm.cupom.amount,
      "validation": true,
      "label": "Valor",
      "masked": false,
      "mask": _vm.amountMask
    },
    on: {
      "input": _vm.updateAmount
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": "",
      "md3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código",
      "value": _vm.cupom.code
    },
    on: {
      "input": _vm.updateCode
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Código para aplicação do desconto.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pr-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Início",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityStartLabel),
      callback: function($$v) {
        _vm.validityStartLabel = $$v
      },
      expression: "validityStartLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityStartPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityStart
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Fim",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.validityEndLabel),
      callback: function($$v) {
        _vm.validityEndLabel = $$v
      },
      expression: "validityEndLabel"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "value": _vm.validityEndPicker,
      "first-day-of-week": 1,
      "locale": "pt-br",
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    on: {
      "input": _vm.updateValidityEnd
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "rules": _vm.rules.limitationType,
      "value": _vm.cupom.limitationType,
      "label": "Limitação de uso",
      "single-line": "",
      "item-text": "label",
      "item-value": "value",
      "items": _vm.listLimitationTypes,
      "required": ""
    },
    on: {
      "input": _vm.updateLimitationType
    },
    model: {
      value: (_vm.cupom.limitationType),
      callback: function($$v) {
        _vm.$set(_vm.cupom, "limitationType", $$v)
      },
      expression: "cupom.limitationType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("Escolha a limitação de uso do desconto.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cupom.limitationType == 2 || _vm.cupom.limitationType == 3),
      expression: "cupom.limitationType == 2 || cupom.limitationType == 3"
    }],
    attrs: {
      "label": "N vezes",
      "value": _vm.cupom.limitation
    },
    on: {
      "input": _vm.updateLimitation
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cupom.limitationType == 2 || _vm.cupom.limitationType == 3),
      expression: "cupom.limitationType == 2 || cupom.limitationType == 3"
    }],
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v("O número de vezes que o desconto pode ser utilizado.")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "pl-2": ""
    }
  }, [_c('p', [_vm._v("Ativo")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.cupom.active
    },
    on: {
      "input": _vm.toggleActive
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md3": "",
      "pl-2": ""
    }
  }, [_c('p', [_vm._v("Para todos os produtos?")]), _vm._v(" "), _c('SelectionBtn', {
    attrs: {
      "value": _vm.cupom.produtos
    },
    on: {
      "input": _vm.toggleProdutos
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "pl-2": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cupom.produtos),
      expression: "!cupom.produtos"
    }],
    attrs: {
      "items": _vm.listItens,
      "label": "Produtos",
      "item-text": "name",
      "item-value": "id",
      "multiple": ""
    },
    model: {
      value: (_vm.cupom.servicoProdutosList),
      callback: function($$v) {
        _vm.$set(_vm.cupom, "servicoProdutosList", $$v)
      },
      expression: "cupom.servicoProdutosList"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm11": "",
      "md11": "",
      "pl-2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "observation",
      "label": "Observação",
      "value": typeof _vm.cupom.observation !== 'undefined' ? _vm.cupom.observation : '',
      "multi-line": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": _vm.updateObservation
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "sm1": "",
      "md1": "",
      "pt-4": "",
      "pl-3": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    }
  }, [_c('v-icon', {
    staticClass: "ml-2 link",
    attrs: {
      "slot": "activator",
      "color": "blue"
    },
    slot: "activator"
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', [_vm._v(" Alguma informação sobre o cupom, por exemplo, cupom válido somente para a região do Morumbi ou cupom válido somente para condomínios da administradora X.")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outline": "",
      "round": "",
      "color": "green",
      "disabled": _vm.loadingCupomAction
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCupom()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("done_all")]), _vm._v("Gravar")], 1)], 1)], 1), _vm._v(" "), (_vm.loadingCupomAction) ? _c('v-progress-linear', {
    staticClass: "loading-modal",
    attrs: {
      "color": "error",
      "indeterminate": true
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ecc1a66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/cupomDetalhe.vue
// module id = 754
// module chunks = 8